import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GlobalBackground from "./components/GlobalBackground";
import Navbar from "./components/Navbar";
import AppShell from "./components/AppShell";
import Footer from "./components/Footer";
import AboutLayout from "./layouts/AboutLayout";
import usePageMeta from "./hooks/usePageMeta";

function PageMeta() {
  usePageMeta();
  return null;
}

export default function App() {
  return (
    <Router>
      <div className="site-shell">
        <PageMeta />
        <GlobalBackground /> {/* Vanta Waves: persistent, never resets */}
        <Navbar />
        <main className="site-main">
          <Routes>
            <Route path="/" element={<AppShell />} />
            <Route path="/about" element={<AboutLayout />} />
            <Route path="/projects" element={<AppShell />} />
            <Route path="/resume" element={<AppShell />} />
            <Route path="/contact" element={<AppShell />} />
            
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}







